import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';
import { from } from 'rxjs';
import { LinkService } from '../../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-language-services-publishing-and-media',
  templateUrl: './language-services-publishing-and-media.component.html',
  styleUrls: ['./language-services-publishing-and-media.component.scss']
})
export class LanguageServicesPublishingAndMediaComponent implements OnInit {

  email: any;
  // emailEnterprise : FormGroup;
  country: string;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    public loadScript: LoadScriptService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle("Empresa Trinka | Serviços de Linguagem, Publicação & Midia");
    this.metaTagService.updateTag({ name: 'description', content: "Permite que suas equipes escrevam de forma consistente, publiquem com mais rapidez e aumenta a experiência do cliente. Reduz o tempo e os custos de escrita sem comprometer a clareza." });
    this.metaTagService.updateTag({ property: 'og:title', content: "Empresa Trinka | Serviços de Linguagem, Publicação & Midia" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Permite que suas equipes escrevam de forma consistente, publiquem com mais rapidez e aumenta a experiência do cliente. Reduz o tempo e os custos de escrita sem comprometer a clareza." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/enterprise/language-services-publishing-and-media' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/enterprise/language-services-publishing-and-media' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/language-services-publishing-and-media'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/language-services-publishing-and-media'});
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/language-services-publishing-and-media' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/language-services-publishing-and-media' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/language-services-publishing-and-media' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/language-services-publishing-and-media' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/language-services-publishing-and-media' });

    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      AOS.init();
    }
  }
  
}
